import { CONTRACT_SEARCH } from './index';
import { Action } from '../action';
import { ContractForm } from '@shared/core';

export class ContractSearchInitAction implements Action {
	readonly type = CONTRACT_SEARCH.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContractSearchDestroyAction implements Action {
	readonly type = CONTRACT_SEARCH.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContractSearchFormUpdateAction implements Action {
	readonly type = CONTRACT_SEARCH.FORM_UPDATE;
	constructor(
		public payload: ContractForm,
		public correlationId?: number
	) {}
}
